const REACT_APP_API_URL = {
  production: {
    mainBaseUrl: "https://fintrack-java-api.kotaholdings.in/business/fintrack",
    hrmsBaseUrl: "https://fintrack-java-api.kotaholdings.in/hrms/fintrack",
    AccountUrl: "https://accounts-production.kotaholdings.in/Api/AccountsMaster",
    AccountsEntry: "https://accounts-production.kotaholdings.in/Api/AccountsEntry",
    AccountsReports: "https://accounts-production.kotaholdings.in/Api/AccountReports",
    leadsUrl: "https://accounts-production.kotaholdings.in",
  },
  stage: {
    mainBaseUrl: "https://fintrack-java-api-stage.kotaholdings.in/business/fintrack",
    hrmsBaseUrl: "https://fintrack-java-api-stage.kotaholdings.in/hrms/fintrack",
    AccountUrl: "https://accounts-stage.kotaholdings.in/Api/AccountsMaster",
    AccountsEntry: "https://accounts-stage.kotaholdings.in/Api/AccountsEntry",
    AccountsReports: "https://accounts-stage.kotaholdings.in/Api/AccountReports",
    leadsUrl: "https://accounts-production.kotaholdings.in",
  },
  local: {
    mainBaseUrl: "http://localhost:9091/fintrack",
    hrmsBaseUrl: "https://fintrack-java-api.kotaholdings.in/hrms/fintrack",
    AccountUrl: "http://localhost:8091/Api/AccountsMaster",
    AccountsEntry: "http://localhost:8091/Api/AccountsEntry",
    AccountsReports: "http://localhost:8091/Api/AccountReports",
    leadsUrl: "https://accounts-production.kotaholdings.in",
  },
};
const { mainBaseUrl, hrmsBaseUrl, AccountUrl, leadsUrl, AccountsEntry, AccountsReports } =
  REACT_APP_API_URL.production;

export const getPresignedUrl = ({ fileName, group = "mis", env = "stage", type = "upload" }) => {
  const baseUrls = {
    stage: "https://s3service.sconexsoft.com",
    production: "https://s3service.sconexsoft.com",
  };
  const bucketNames = {
    mis: {
      stage: "fintrackmisstage",
      production: "fintrackmisprod",
    },
    disbursement: {
      stage: "fintrackdisbursementstage",
      production: "fintrackdisbursementprod",
    },
  };

  const baseUrl = baseUrls[env];
  const bucketName = bucketNames[group]?.[env];

  if (!bucketName || !baseUrl) {
    throw new Error("Invalid group or environment");
  }

  return `${baseUrl}/s3bucket/presigned-url?fileName=${encodeURIComponent(
    fileName
  )}&bucketName=${bucketName}&operation=${type}`;
};
const URLs = {
  dmaPayoutBreakdown: `${mainBaseUrl}/dma-payout-breakdown`,
  byfurcationOfExpenses: `${mainBaseUrl}/expenses-breakdown`,

  createPaymentVoucher: `${mainBaseUrl}/accounts/create-salary-jv`,
  getProdReceiptVouchersUrl: `${mainBaseUrl}/headOfficeInvoiceReceiptDetail`,
  ctcPmtVouchersGetUrl: `${mainBaseUrl}/accounts/payroll`,
  invoiceRecieptDetailsUrl: `${mainBaseUrl}/headoffice-invoice-recovery-invoice-receiptdetail`,
  printJvInvoiceUrl: `${mainBaseUrl}/headoffice-credit-note-PdfView`,
  makeJvInvoiceUrl: `${mainBaseUrl}/head-office-recovery-invoice-pdfview`,
  makeRecoveryInvoiceUrl: `${mainBaseUrl}/save-recovery-amount`,
  getRecievedDibursements: `${mainBaseUrl}/amount-received-invoices`,
  getYetToReceiveInvoices: `${mainBaseUrl}/headOfficeInvoiceReceiptDetail`,
  dmaReceviedBusinessBreakdownUrl: `${mainBaseUrl}/dma-business-breakdown/received-amount`,
  dmaNotReceviedBusinessBreakdownUrl: `${mainBaseUrl}/dma-business-breakdown/not-received-amount`,
  dmaAllBusinessByMisDate: `${mainBaseUrl}/dma-alldisbursedbusiness-businessdate`,
  dmaActualPandLReportByMisDate: `${mainBaseUrl}/profit-loss-business-date-dma`,
  khAllDisbursedBusinessUrl: `${mainBaseUrl}/alldisbursedbusiness-businessdate`,
  notReceivedBusinessBreakdownUrl: `${mainBaseUrl}/business-breakdown/not-received-amount`,
  receivedBusinessBreakdownUrl: `${mainBaseUrl}/business-breakdown/received-amount`,
  profitAndLossByMisDate: `${mainBaseUrl}/profit-loss-business-date`,
  dsaMIS: `${mainBaseUrl}/loan-summaries/by-date-range/misStatus`,
  dsaMISByDsaId: `${mainBaseUrl}/business-entries-new-status`,
  headOfficeMis: `${mainBaseUrl}/loan-summaries/by-date-range/misStatus`,
  misreport: `${mainBaseUrl}/mis-report`,
  dsaBusinessBreakdownUrl: `${mainBaseUrl}/dma-BusinessBreakDownByDate/dsa`,
  extendedPayout: `${mainBaseUrl}/invoices/extended-payout`,
  getEntriesForExtendedInvoice: `${mainBaseUrl}/extendedInvoiceEntries`,
  dmaEstimatedPandLReport: `${mainBaseUrl}/dma/profit-and-loss`,
  dmaActualPandLReport: `${mainBaseUrl}/dma/ExpenseAndRevenueDetail`,
  balanceSheet: `${mainBaseUrl}/balanceSheet`,
  connectorBrekdownUrl: `${mainBaseUrl}/conPaymentsByDSA`,
  additionalpayoutsBrekdownUrl: `${mainBaseUrl}/additional-payouts`,
  recoveriesBrekdownUrl: `${mainBaseUrl}/recoveries`,
  businessBreakdownUrl: `${mainBaseUrl}/business-breakDown`,
  accountwisereceivedbusinessbreakdown: `${mainBaseUrl}/account-wise-received-business-breakdown`,
  khActualPandLReport: `${mainBaseUrl}/expenseAndRevenueDetail`,
  leadGetALLUrl: `${leadsUrl}/Api/LeadApp/leads`,
  leadGetByIdUrl: `${leadsUrl}/Api/LeadApp/GetLeadWorklog`,
  getAllCallLogs: `${leadsUrl}/Api/LeadApp/GetDailyLeadCalls`,
  getCallLogsById: `${leadsUrl}/Api/LeadApp/GetDayCallLog`,
  newPLreportUrl: `${mainBaseUrl}/profit-and-loss`,
  newConnectorPayment: `${mainBaseUrl}/connector-Payment`,
  getConnectors: `${mainBaseUrl}/non-gstDSADetails`,
  getEntriesForConnector: `${mainBaseUrl}/connetor-details?assignCompanyId`,
  getFilteredEntries: `${mainBaseUrl}/getFilteredDsaNames`,
  updateDSAreceiptby: `${mainBaseUrl}/updateDSAreceiptby`,
  updateKhReceiptBy: `${mainBaseUrl}/updatereceiptby`,
  fetchtingKhInvoices: `${mainBaseUrl}/getCompanyInvoicedetailsby`,
  fetchtingDsaInvoices: `${mainBaseUrl}/getDsaInvoiceDetailsby`,
  dibursementAbort: `${mainBaseUrl}/abortDisbursement`,
  allPayoutsNotReceivableNotRaisedInvoice: `${mainBaseUrl}/allPayoutsNotReceivableNotRaisedInvoice`,
  receivableNotRaisedInvoices: `${mainBaseUrl}/dsaAcctReceivablesNotRaisedInvoices`,
  receivableAgainstDsa: `${mainBaseUrl}/dsaAcctReceivablesRaisedInvoicesByDsaId`,
  receivableAgainstDsaKh: `${mainBaseUrl}/headOfficeAcctReceivablesRaisedInvoicesByDsaId`,
  recivableWithoutDateRangeKh: `${mainBaseUrl}/headOfficeSummaryReport`,
  recivablesWithoutDateRange: `${mainBaseUrl}/dsaSummaryReport`,
  dsaAcctReceivablesNotRaisedInvoices: `${mainBaseUrl}/dsaAcctReceivablesNotRaisedInvoices`,
  dsaReceivablesKh: `${mainBaseUrl}/headOfficeSummaryReport/dataRange`,
  dsaReceivables: `${mainBaseUrl}/dsaSummaryReport/dataRange`,
  confirmedAcctWiseAllDsaBusiness: `${mainBaseUrl}/confirmed-acct-wise-all-dsa-buisness`,
  pAndLByDsaId: `${mainBaseUrl}/actualProftLossReportByDsaId`,
  dsaFinancialDetailss: `${mainBaseUrl}/dsaFinancialReport`,
  khInvoiceViewUrl: `${mainBaseUrl}/headofficeInvoicePdfView`,
  businessMaster: `${mainBaseUrl}/businessDetails`,
  actualProftLoassReport: `${mainBaseUrl}/actualProftLossReport`,
  mis: `${mainBaseUrl}/mis`,
  insuranceFirstSchedule: `${mainBaseUrl}/firstSheduleBusinessByDateRange`,
  unPaidInsuranceUrl: `${mainBaseUrl}/insurance/unpaid-not-in-current-month`,
  insuranceRevenu: `${mainBaseUrl}/insuranceBusiness`,
  applicantsByIdd: `${hrmsBaseUrl}/getallapplicantsby`,
  insuranceReportsUrl: `${mainBaseUrl}/insuranceMontlyRenewalyData`,
  insuranceGetAllEntries: `${mainBaseUrl}/insuranceReports`,
  updateDisbursement: `${mainBaseUrl}/disburseDetails`,
  insuranceAgents: `${hrmsBaseUrl}/employees`,
  pipelinePost: `${mainBaseUrl}/pipeLineDetails`,
  pipeLineDelete: `${mainBaseUrl}/pipeLineDetailsById`,
  insuranceConfigs: `${mainBaseUrl}/insuranceConfigs`,
  pipelinePut: `${mainBaseUrl}/pipeLineDetails`,
  pipelineGet: `${mainBaseUrl}/pipeLineDetails/by-date-range`,
  totalExpenses: `${mainBaseUrl}/expenses/dataRange`,
  updateInsurancePaidStatus: `${mainBaseUrl}/insurancePayment/updateStatus`,
  updateInsurancePayoutStatus: `${mainBaseUrl}/insuranceCofirm/updateStatus`,
  insuranceMainURl: `${mainBaseUrl}/insurancePremiumDetailsByPaidStatusAndPayoutStatus`,
  getInsuranceEntries: `${mainBaseUrl}/getInsuranceEntries/businessType/dataRange?businessType=IN&`,
  updateInsuranceEntry: `${mainBaseUrl}/updateInsuranceEntries`,
  deleteInsuranceEntry: `${mainBaseUrl}/deleteInsuranceEntry`,
  insuranceEntry: `${mainBaseUrl}/businessInsuranceEntries`,
  businessLogin: `${mainBaseUrl}/login`,
  totalListOfExpenses: `${mainBaseUrl}/expenses?`,
  totaleExpenditureStatement: `${mainBaseUrl}/totalExpenditure?`,
  resumeEntry: `${mainBaseUrl}/resume-entryAbort`,
  abortEntry: `${mainBaseUrl}/abort-Update-status`,
  headOfficeBanksAcc: `${mainBaseUrl}/companyBankNames`,
  userManuByModuleId: `${hrmsBaseUrl}/GetMenuAccessDetails`,
  dsaMonthEndUrl: `${mainBaseUrl}/monthEndDsaDetails`,
  connectorWiseBusinessByDsaId: `${mainBaseUrl}/connector-wise/report/byDsa?`,
  connectorWiseEntriesBusinessByDsaId: `${mainBaseUrl}/loansummeries/subDsaBydsa?`,
  provderWiseBusinessByDsaId: `${mainBaseUrl}/provider/by-dsa?`,
  khproviderwisebusiness: `${mainBaseUrl}/kh-provider-wise-business?`,
  providerWiseEntriesByDsaId: `${mainBaseUrl}/loansummeries-finance-ByDsa?`,
  productWiseEntriesByDsaId: `${mainBaseUrl}/loansummary-businesswise/dsa?`,
  productWiseBusinessByDsaId: `${mainBaseUrl}/product/by-dsa?`,
  khproductwisereport: `${mainBaseUrl}/kh-product-wise-report?`,
  newDsaPostUrl: `${mainBaseUrl}/insertDsaDetailsWothEmployee`,
  employeeNamesByCompanyBase: `${hrmsBaseUrl}/employeeNames/by-company`,
  dsaDashboardUrl: `${mainBaseUrl}/api/dashboardByDsaWise`,
  bussinessDisbursement: `${mainBaseUrl}/disbusres`,
  getEntriesByDateRange: `${mainBaseUrl}/by-dsa-and-date`,
  newPostConfirmPayRoll: `${hrmsBaseUrl}/EmpconfromPayroll`,
  newPostRunPayRoll: `${hrmsBaseUrl}/runEmployeePayroll`,
  newGetconfirmPayRoll: `${hrmsBaseUrl}/confromEmpPayroll`,
  newGetRunPayRoll: `${hrmsBaseUrl}/getEmployeePayroll`,
  offerLetter: `${hrmsBaseUrl}/pdfGenerator/offer-letter`,
  deleteAdvance: `${hrmsBaseUrl}/deleteAdvanceDetails`,
  grantAdvance: `${hrmsBaseUrl}/grantAdvance`,
  updateAdvanceDetails: `${hrmsBaseUrl}/updateAdvanceDetails`,
  approveOrRejectdvance: `${hrmsBaseUrl}/approveAdvance-or-reject`,
  getAllAdvanceDetails: `${hrmsBaseUrl}/advanceDetails`,
  getEmployeeAdvanceDetails: `${hrmsBaseUrl}/employee`,
  updateAproveLeave: `${hrmsBaseUrl}/update-approval-status`,
  empLeaveDetailsAll: `${hrmsBaseUrl}/empLeavesDetails`,
  deleteEmpLeaves: `${hrmsBaseUrl}/deleteEmpLeavesBy`,
  insertLeaves: `${hrmsBaseUrl}/insertempLeavesDetails`,
  empUpdatesLeaves: `${hrmsBaseUrl}/updateEmpLeavesBy`,
  empLeaveDetails: `${hrmsBaseUrl}/empLeavesDetailsBy`,
  empLeaveDetailsByPayPeriod: `${hrmsBaseUrl}/empLeaveDetails-by`,
  connectorPaymentConfirmation: `${mainBaseUrl}/connectors/status`,
  updateMenuDetails: `${hrmsBaseUrl}/UpdateMenuDetails`,
  menuDetailsByRoleId: `${hrmsBaseUrl}/menuDetailsBy`,
  hrmsRoleDetails: `${hrmsBaseUrl}/roleDetails`,
  connectorPaymentEligibleEntries: `${mainBaseUrl}/connectorsPaymentDetails`,
  advanceConfirmation: `${mainBaseUrl}/addAdvance`,
  spotPaymentsEligibleEntries: `${mainBaseUrl}/spotPaymentDetails`,
  hrmsConfirmPayRoll: `${hrmsBaseUrl}/confromPayroll`,
  hrmsRunPayRoll: `${hrmsBaseUrl}/runPayroll`,
  hrmsPayRollIdUrl: `${hrmsBaseUrl}/payRollDetails`,
  hrmsEmployeesByCompanyId: `${hrmsBaseUrl}/employees`,
  hrmsDsaLoginDetailsUrl: `${hrmsBaseUrl}/dsaDetails`,
  hrmsLoginUrl: `${hrmsBaseUrl}/login`,
  hrmsDeletePayrollUrl: `${hrmsBaseUrl}/deleteEmployeeAddPayroll`,
  hrmsUpdatePayRollUrl: `${hrmsBaseUrl}/update/employeeAddPayroll`,
  getEmpPayRollData: `${hrmsBaseUrl}/employeeAddPayrollDetails`,
  hrmsPaymapStructs: `${hrmsBaseUrl}/update/empMapPayStructures`,
  hrmsPayrollAddedEmployees: `${hrmsBaseUrl}/by-company/empPayrollDetails`,
  hrmsBankDetailsUrl: `${hrmsBaseUrl}/bankDetails`,
  hrmsEmpLeaveUrl: `${hrmsBaseUrl}/leaveMasterDetails`,
  hrmsGetPayStructuresUrl: `${hrmsBaseUrl}/empMapPayStructures`,
  hrmsPayStructsByCid: `${hrmsBaseUrl}/pay-structures`,
  hrmsPostUrl: `${hrmsBaseUrl}/process`,
  hrmsGetPayRoll: `${hrmsBaseUrl}/getPayroll`,
  hrmsAddEmpToPayStruct: `${hrmsBaseUrl}/insertEmpMapPayStructures`,
  hrmsPayStructDetails: `${hrmsBaseUrl}/insertPaystructDetails`,
  hrmsCompanyDetails: `${hrmsBaseUrl}/companyDetails`,
  hrmsGetAllPayStructures: `${hrmsBaseUrl}/pay-structures`,
  hrmsPayStructure: `${hrmsBaseUrl}/pay-structure`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  deleteAddEmppayroll: `${hrmsBaseUrl}/deleteAddEmppayroll`,
  hrmsEmployeePayrollUrl: `${hrmsBaseUrl}/employeePayrollDetails`,
  hrmsCompanyPayrollStatusUrl: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsFetchEmploeeLeaveTypeUrl: `${hrmsBaseUrl}/leaveMasterDetails`,
  hrmsInsertEmployeeLeaveUrl: `${hrmsBaseUrl}/insertempLeavesDetails`,
  hrmsPostAttendanceUrl: `${hrmsBaseUrl}/attendanceDetails`,
  hrmscompanyDetailsUrl: `${hrmsBaseUrl}/companyDetails`,
  hrmsCompanyCalanderDetailsUrl: `${hrmsBaseUrl}/ComapanyCalanderDetails`,
  hrmsEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsPostSalaryAdvanceUrl: `${hrmsBaseUrl}/advanceDetails`,
  hrmsCalendarYearsUrl: `${hrmsBaseUrl}/calendar-years`,
  hrmsAttendanceListUrl: `${hrmsBaseUrl}/employeesList`,
  hrmsLeaveBalanceUrl: `${hrmsBaseUrl}/Leavebalance`,
  hrmsAdvanceDetailsUrl: `${hrmsBaseUrl}/advancedetails`,
  hrmsUpdateLeaveUrl: `${hrmsBaseUrl}/update-approval-status`,
  hrmsDeletePayStructBy: `${hrmsBaseUrl}/deletepaystructby`,
  hrmsDeletePayStructMapping: `${hrmsBaseUrl}/deletepaystructmappingby`,
  hrmsPostPayStructMapping: `${hrmsBaseUrl}/postPaystructMapping`,
  hrmsEmployeeMasterGetUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsApproveOrRejectdvance: `${hrmsBaseUrl}/approveAdvance-or-reject`,
  hrmsExistingAdvanceUrl: `${hrmsBaseUrl}/existingAdvance`,
  hrmsEmployeeAdvanceDetailsUrl: `${hrmsBaseUrl}/employee`,
  hrmsGetNotEmployees: `${hrmsBaseUrl}/getnotemployees`,
  hrmsPostEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsGetEmployeeDetailsUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsUpdatePassword: `${hrmsBaseUrl}/updatePassword`,
  hrmsGetAllApplicants: `${hrmsBaseUrl}/getallapplicants`,
  hrmsUpdatePayStructBy: `${hrmsBaseUrl}/updatepaystructby`,
  hrmsUpdateApplicantPayStruct: `${hrmsBaseUrl}/updateapplicantpaystructby`,
  hrmsGetPayStructById: `${hrmsBaseUrl}/getpaystructby`,
  hrmsGetPayStructDetailsById: `${hrmsBaseUrl}/getpay-structuredetailsby`,
  // calendarYearsUrl: `${hrmsBaseUrl}/calendar-years`,
  hrmsGetRoleDetails: `${hrmsBaseUrl}/roleDetails`,
  hrmsPostApplicant: `${hrmsBaseUrl}/postApplicant`,
  hrmsUpdateApplicant: `${hrmsBaseUrl}/updateby`,
  hrmsDeleteApplicant: `${hrmsBaseUrl}/deleteby`,
  hrmsGetAllApplicantsPayStructures: `${hrmsBaseUrl}/getallapplicantspaystructures`,
  hrmsGetPayPeriods: `${hrmsBaseUrl}/GetMonthNames`,
  hrmsViewPayslips: `${hrmsBaseUrl}/viewPayslipsby`,
  hrmsPayslipPdf: `${hrmsBaseUrl}/payslipPdf`,
  hrmsRunPayroll: `${hrmsBaseUrl}/run`,
  hrmsConfirmPayroll: `${hrmsBaseUrl}/confirm`,
  hrmsPostRunPayroll: `${hrmsBaseUrl}/RunPayRoll`,
  hrmsPostConfirmPayroll: `${hrmsBaseUrl}/ConfirmPayroll`,
  hrmsGetAttendanceList: `${hrmsBaseUrl}/employeesList-by`,
  //teja urls hrms
  hrmsPayStructure: `${hrmsBaseUrl}/pay-structures`,
  hrmsBankDetails: `${hrmsBaseUrl}/bankDetails`,
  hrmsEmployeesLevel: `${hrmsBaseUrl}/levelDetails`,
  hrmsDepartmentUrl: `${hrmsBaseUrl}/departDetails`,
  addEmployeeToPayRoll: `${hrmsBaseUrl}/addPayroll`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsGetEmployeedByPayRollStatus: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsGetEmployeedByPayRollStatus: `${hrmsBaseUrl}/by-company-payRollstatus`,
  hrmsGetOfferLetterPrint: `${hrmsBaseUrl}/offer-letterforApplicant`,
  //fintrack old urls.
  headOfficeApprovedInvoices: `${mainBaseUrl}/headOfficeInvoiceReceiptDetail`,
  headOfficeInvoiceConfirmation: `${mainBaseUrl}/companyInvoiceReceiptDetails`,
  headOfficeInvoiceRaising: `${mainBaseUrl}/headOfficeInvoicedetails`,
  headOfficeInvoiceCancelation: `${mainBaseUrl}/cancelHeadOfficeInvoices`,
  headOfficeInvoicePrintAndApprove: `${mainBaseUrl}/headOfficeInvoicePrint`,
  headOfficeInvoices: `${mainBaseUrl}/headOfficeInvoiceDetail`,
  headOfficeInvoiceEligibleEntries: `${mainBaseUrl}/headOfficeInvoiceEligibleEntries`,
  headOfficeConfirmDsaInvoicePay: `${mainBaseUrl}/updatePayments-invoice`,
  headOfficeUnPaidInvoices: `${mainBaseUrl}/receiptPaymentDetailsAprovedByCompany`,
  headOfficePaymentConfirmation: `${mainBaseUrl}/submitInvoicePayment`,
  headOfficeInvoiceView: `${mainBaseUrl}/dsaInvoicePdfView`,
  headOfficeInvoiceCheck: `${mainBaseUrl}/head-office-invoice-check`,
  headOfficeApprovedMIS: `${mainBaseUrl}/updateDsaReview-invoice`,
  headOfficeDsaMISApprovalUrl: `${mainBaseUrl}/review-mis-status`,
  invoiceEligibleEntriesByDsaId: `${mainBaseUrl}/invoiceEligibleEntries-dsaId`,
  businessEntriesByCompanyIdAndStatus: `${mainBaseUrl}/by-status/bycompany/filter`,
  businessEntriesByCompanyId: `${mainBaseUrl}/by-type-and-dsa`,
  headOfficeMISUrl: `${mainBaseUrl}/loan-summaries/by-date-range/misStatus`,
  dsaMISUrl: `${mainBaseUrl}/loan-summaries/by-date-range/misStatus/dsaId`,
  fecthEmlFile: `${mainBaseUrl}/s3bucket/presigned-url`,
  fileAttachmentUrl: `${mainBaseUrl}/s3bucket/presigned-url`,
  cancelInvoiceUrl: `${mainBaseUrl}/cancelInvoices`,
  postDsaReceiptUrl: `${mainBaseUrl}/invoiceReceiptDetails`,
  dsaReceiptsUrl: `${mainBaseUrl}/dsaReceiptDetailsBydsaId?dsaId`,
  invoicedDsaUrl: `${mainBaseUrl}/status-dsa-details`,
  dsaInvoicePrintUrl: `${mainBaseUrl}/dsainvoicePrint`,
  invoiceEligibleEntries: `${mainBaseUrl}/invoiceEligibleEntries`,
  dsaInvoicedGetUrl: `${mainBaseUrl}/dsaInvoiceDetail`,
  dsaInvoiceUrl: `${mainBaseUrl}/dsainvoicedetails`,
  invoiceEligibleUrl: `${mainBaseUrl}/invoiceEntries-businessStatus?businessStatus`,
  bankAccountsByDsaId: `${mainBaseUrl}/by-dsa`,
  dsaBankAccountUrl: `${mainBaseUrl}/accountDetails`,
  disbursalEntriesPostUrl: `${mainBaseUrl}/disburseDetails`,
  disbursalEntriesUrl: `${mainBaseUrl}/api/disbursed-entries-dsaId`,
  loanSummariesByMisStatus: `${mainBaseUrl}/loan-summaries/misStatus?misStatus=`,
  entryMisStateUpdateUrl: `${mainBaseUrl}/api/entriesupdate-status`,
  monthlyMisData: `${mainBaseUrl}/api/loansumeries`,
  dsaWiseBusinessByDateRange: `${mainBaseUrl}/dsamonthlybusiness/date-range?`,
  dsaWiseBusinessEntriesByDateRange: `${mainBaseUrl}/dsabusinessentries{dsaId}/date-range?`,
  productWiseBusinesByDateRange: `${mainBaseUrl}/productwise/report?`,
  alldsaproductwisereport: `${mainBaseUrl}/all-dsa-product-wise-report?`,
  providerWiseBusinesByDateRange: `${mainBaseUrl}/providerwise/report?`,
  alldsaproviderbusiness: `${mainBaseUrl}/all-dsa-provider-business?`,
  connectorWiseBusinesByDateRange: `${mainBaseUrl}/connector-wise/report?`,
  monthlyBusinesssByDateRange: `${mainBaseUrl}/api/loan-summaries/by-date-range?`,
  productWiseBusiness: `${mainBaseUrl}/productwisebusiness`,
  productWiseBusinessByProductId: `${mainBaseUrl}/loanSummary`,
  khproductwisebifurcated: `${mainBaseUrl}/all-dsa-productwise-bifurcated`,
  providerWiseBusinessEntriesURL: `${mainBaseUrl}/loanSummaryByFinanceId?finananceId=`,
  khproviderbusinessbifurcatedreport: `${mainBaseUrl}/all-dsa-provider-business-bifurcated-report`,
  connectorWiseEntriesByDateRange: `${mainBaseUrl}/loanSummaryBySubDsa?subDsaId=`,
  logiApiUrl: `${mainBaseUrl}/login`,
  companyURl: `${mainBaseUrl}/companyDetails`,
  providerUrl: `${mainBaseUrl}/provider-wise-business`,
  monthEndReportUrl: `${mainBaseUrl}/LoanSummaries`,
  dashboardUrl: `${mainBaseUrl}/api/dashboard?date=`,
  businessMonthDatesUrl: `${mainBaseUrl}/businessMonthYear`,
  connectorUrl: `${mainBaseUrl}/connector-wise-business`,
  dashboardLoansUrl: `${mainBaseUrl}/statusAproval?currentStatus=D&businessType=BL`,
  logiApiUrl: `${mainBaseUrl}/validate`,
  companyConfigurationUrl: `${mainBaseUrl}/companyDetails`,
  employeeMasterGetUrl: `${mainBaseUrl}/employeeDetails`,
  dsaMasterGetUrl: `${mainBaseUrl}/dsaDetails`,
  partialFullyDisburseReport: `${mainBaseUrl}/partial-fully-disburse-report-by-dsaId`,
  roleGetUrl: `${mainBaseUrl}/roleDetails`,
  fileUpload: `${mainBaseUrl}/import-csv`,
  finanaceGetUrlByTypeCodeUrl: `${mainBaseUrl}/finance`,
  financeBusinessGetUrl: `${mainBaseUrl}/businessDetails`,
  financeUrl: `${mainBaseUrl}/financeDetails`,
  entriesUrlById: `${mainBaseUrl}/financeDetailsByBusinessId`,
  baseUrl: mainBaseUrl,
  employeeDetailsByRoleIdUrl: `${mainBaseUrl}/employeesByRoleId`,
  businessEntriesUrl: `${mainBaseUrl}/api/businessEntries`,
  monthEndUrl: `${mainBaseUrl}/monthEndDetails`,
  monthlyBusinessUrl: `${mainBaseUrl}/monthlyBusiness`,
  financeGetAllUrl: `${mainBaseUrl}/financeDetails`,
  accountsUrl: `${AccountUrl}/GetCashBankAccounts`,
  appAccessURl: `${mainBaseUrl}/details`,
  accessControlApi: `${mainBaseUrl}/loginEmployeeDetails`,
  PasswordUpdate: `${mainBaseUrl}/update`,
  removeAccess: `${mainBaseUrl}/delete`,
  removeRemaining: `${mainBaseUrl}/delete`,
  ParentGroupUrl: `${AccountUrl}/getParentGroups`,
  AllGroupUrl: `${AccountUrl}/getAllGroups`,
  PostAccountGroupUrl: `${AccountUrl}/postAccountGroup`,
  GetAccountsUrl: `${AccountUrl}/GetAccounts`,
  PostAccountLedger: `${AccountUrl}/postAccountLedger`,
  GetCashBankAccounts: `${AccountUrl}/GetCashBankAccounts`,
  GetCompanies: `${AccountUrl}/GetCompanies`,
  GetPaymentAccounts: `${AccountUrl}/GetPaymentAccounts`,
  PostVoucherEntry: `${AccountUrl}/PostVoucherEntry`,
  GetJVItem: `${AccountsEntry}/GetJVItem`,
  PostVoucherEntry: `${AccountsEntry}/PostVoucherEntry`,
  GetVoucherEntryList: `${AccountsEntry}/GetVoucherEntryList`,
  GetLedgerAccounts: `${AccountUrl}/GetLedgerAccounts`,
  getLedger: `${AccountsReports}/getLedger`,
  AccountPayableAndrURL: `${mainBaseUrl}/api/account-payable/Andromeda`,
  AccountReceivableAndrURL: `${mainBaseUrl}/accountReceivable/Andromeda`,
  AccountPayableDsaURL: `${mainBaseUrl}/accountpayblesubDsa`,
  AccountReceivableDsaURL: `${mainBaseUrl}/accountReceivableDsa`,
  EmployeeProductivity: `${mainBaseUrl}/employeeProductivity`,
  hrmsRoleDetailsUrl: `${hrmsBaseUrl}/roleDetails`,
  hrmsEmployeeMasterUrl: `${hrmsBaseUrl}/employeeDetails`,
  hrmsUpdatePassword: `${hrmsBaseUrl}/updatePassword`,
  dashboardBlUrl: `${mainBaseUrl}/statusAproval?currentStatus=C&businessType=BL`,
  gstSummary: `${mainBaseUrl}/gst-summary`,
  gstliability: `${mainBaseUrl}/gst-liability-bifurcated-report`,
  igstliability: `${mainBaseUrl}/igst-liability-bifurcated-report`,
  salaryPayableBifurcated: `${mainBaseUrl}/balance-sheet-salary-payble-bifurcated`,
  gstpaid: `${mainBaseUrl}/gst-paid-bifurcated-report`,
  igstpaid: `${mainBaseUrl}/igst-paid-bifurcated-report`,
  gstreceivable: `${mainBaseUrl}/gst-receivable-bifurcated-report`,
  khProductTypeBusinessBreakdown: `${mainBaseUrl}/kh-product-type-business-breakDown`,
  dmabusinessbreakdownbusinesstypecode: `${mainBaseUrl}/dma-business-breakdown-business-type-code`,
  khmisproducttypebusinessbreakDown: `${mainBaseUrl}/kh-mis-product-type-business-breakDown`,
  dmamisbusinessbreakdownbusinesstypecode: `${mainBaseUrl}/dma-mis-business-breakdown-business-type-code`,
  pendingDisbursementsUrl: `${mainBaseUrl}/pending-disbursements?`,
  dmaAmountReceivedInvoices: `${mainBaseUrl}/dma-amount-received-invoices`,
  dsaRecoveryInvoiceReceiptDetails: `${mainBaseUrl}/dsa-recovery-invoice-receipt-details`,
  dmaSaveRecoveryUrl: `${mainBaseUrl}/dma-save-recovery-amount`,
  dsaCreditNoteInvoiceView: `${mainBaseUrl}/dsa-credit-note-PdfView`,
};

export default URLs;
